const api = [
  {
    name: 'moduleList',
    desc: '获取当前模块列表',
    method: 'GET',
    path: 'module/list'
  },
  {
    name: 'moduleDetail',
    desc: '功能/页面/菜单详情',
    method: 'GET',
    path: 'module/detail'
  },
  {
    name: 'moduleAdd',
    desc: '新增/修改模块',
    method: 'POST',
    path: 'module/add'
  },
  {
    name: 'checkCode',
    desc: '判断功能编码是否不存在',
    method: 'GET',
    path: '/function/code/check'
  },
  {
    name: 'funList',
    desc: '菜单列表',
    method: 'GET',
    path: '/function/tree'
  },
  {
    name: 'funAdd',
    desc: '新增/修改菜单',
    method: 'POST',
    path: '/function/add'
  },
  {
    name: 'status',
    desc: '启用/禁用菜单功能',
    method: 'POST',
    path: '/function/edit/status'
  },
  {
    name: 'funDetail',
    desc: '功能/页面/菜单详情',
    method: 'GET',
    path: '/function/detail'
  },
  {
    name: 'delete',
    desc: '删除',
    method: 'POST',
    path: '/function/delete',
    append: true
  },
  {
    name: 'editStatus',
    desc: '修改功能状态',
    method: 'POST',
    path: '/function/edit/status'
  }
]

export default {
  BASE_URL: '',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/fun.js